<template>
  <div class="space-y-6 px-3 pb-6 md:px-6">
    <!-- <logo-component /> -->
    <div class="flex flex-col">
      <div class="text-ontick-steel-900 flex items-center pt-12 font-semibold dark:text-gray-300">
        <span class="text-xl sm:text-2xl">Seja bem-vindo(a), {{ name }}</span>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6">
      <div
        class="bg-ontick-steel-100 dark:bg-ontick-graphite-500 col-span-full grid grid-cols-3 gap-6 rounded-lg p-6 xl:col-span-10"
      >
        <div class="line dark:box-shadow col-span-full flex flex-col rounded-lg lg:col-span-2">
          <div class="flex items-start justify-between">
            <div class="w-full space-y-6">
              <div class="flex w-full flex-col justify-between space-y-4 sm:flex-row sm:space-y-0">
                <dashboard-account-select-component @account-selected="getIncome(getSelectedAccount.account_id)" />
                <div class="flex items-center justify-between space-x-4">
                  <button
                    @click="refreshDashboard"
                    class="text-ontick-blue-600 dark:bg-ontick-steel-500 rounded-md bg-gray-50 p-2 shadow"
                  >
                    <i v-html="update_icon_active ? update_icon.active : update_icon.disabled"></i>
                  </button>

                  <div class="relative w-full">
                    <VueCtkDateTimePicker
                      id="dashboard-datepicker"
                      class="dashboard-datepicker w-full rounded-md shadow sm:w-56"
                      v-model="calendarSelected"
                      label="Selecione o periodo"
                      :range="true"
                      :dark="getUiTheme === 'DARK' ? true : false"
                      :only-date="true"
                      locale="pt-BR"
                      :noClearButton="true"
                      :no-button-now="true"
                      :custom-shortcuts="customShortcuts"
                      format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                      :max-date="moment().toISOString()"
                      :disabled-weekly="[0, 6]"
                      formatted="D MMM YYYY"
                      @validate="getIncome(getSelectedAccount.account_id)"
                      :no-value-to-custom-elem="true"
                    >
                    </VueCtkDateTimePicker>
                    <span
                      class="dark:bg-ontick-steel-500 xs:block absolute inset-y-2.5 right-2 hidden bg-gray-50 pl-2"
                      v-html="$icons.calendar"
                    />
                  </div>
                </div>
              </div>
              <div>
                <h2 class="text-ontick-carbon-900 dark:text-gray-300">Resultado</h2>
                <div class="flex items-center space-x-3">
                  <svg
                    v-if="line_chart.length > 0 && visible"
                    width="13"
                    height="10"
                    viewBox="0 0 13 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="transform transition-all duration-200"
                    :class="statistics.pnl > 0 ? 'rotate-0' : 'rotate-180'"
                  >
                    <path d="M12.5 10H0L6.25 0L12.5 10Z" :fill="statistics.pnl > 0 ? '#19D684' : '#F56565'" />
                  </svg>
                  <div
                    v-if="loading"
                    class="w-20 rounded-md border border-ontick-steel-300 bg-gray-50 dark:border-ontick-graphite-500 dark:bg-ontick-graphite-500"
                  >
                    <div class="flex animate-pulse">
                      <div class="h-4 w-full rounded bg-ontick-steel-100 dark:bg-ontick-steel-500"></div>
                    </div>
                  </div>
                  <h3
                    v-else
                    class="text-ontick-carbon-900 whitespace-nowrap font-semibold dark:text-gray-100 sm:text-xl"
                  >
                    <template v-if="!visible"> R$ --- </template>
                    <template v-else-if="statistics.pnl">
                      {{ statistics.pnl | currency }}
                    </template>
                    <template v-else>
                      {{ 0 | currency }}
                    </template>
                  </h3>
                  <button
                    @click="setVisibility()"
                    class="text-ontick-steel-900 ml-3 dark:text-gray-300"
                    v-html="visible ? $icons.eye : $icons.eye_off"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <template v-if="loading">
            <placeholder-card-component :qtd="4" />
          </template>
          <template v-else-if="visible && !loading">
            <div v-if="line_chart.length > 0" class="h-full">
              <v-chart autoresize :option="chart_line"></v-chart>
            </div>
            <div v-if="line_chart.length === 0" class="relative flex h-[250px] items-center justify-center">
              <h2 class="text-ontick-carbon-900 text-center text-2xl font-semibold dark:text-gray-100">
                Nenhuma operação realizada.
              </h2>
            </div>
          </template>
          <div v-else class="relative flex h-[250px] items-center justify-center">
            <h2 class="text-ontick-carbon-900 text-center text-2xl font-semibold italic dark:text-gray-100">
              Dados ocultos
            </h2>
          </div>
        </div>
        <div class="col-span-full flex flex-col space-y-6 md:px-0 lg:col-span-1">
          <dashboard-table-component
            :data="sorted.positive"
            title="Melhor desempenho do período"
            :visibility="visible"
            :loading="loading"
            positive
          />
          <dashboard-table-component
            :data="sorted.negative"
            title="Pior desempenho do período"
            :visibility="visible"
            :loading="loading"
            :positive="false"
          />
        </div>
        <div class="col-span-full">
          <!-- CARDS -->
          <dashboad-card-component
            :visibility="visible"
            v-if="Object.keys(statistics).length > 0 && !loading"
            :statistics="statistics"
          />
          <!-- PLACEHOLDER -->
          <div
            v-if="Object.keys(statistics).length == 0 || loading"
            class="grid grid-cols-2 gap-6 text-center sm:grid-cols-3 lg:grid-cols-6"
          >
            <placeholder-card-component v-for="i in 6" :key="i" :qtd="1" />
          </div>
        </div>
      </div>
      <iframe
        :src="banner"
        class="col-span-full h-full w-full rounded-lg shadow-xl xl:col-span-2"
        frameBorder="0"
        id="banner"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VChart from "vue-echarts";
import EventBus from "@/app/shared/utils/event_bus";
import DashboardAccountComponent from "./components/dashboard.account.component.vue";
import PlaceholderCardComponent from "../../shared/components/placeholder/placeholder-card.component.vue";
import LogoComponent from "../../shared/components/logo/logo.component.vue";
import DashboadCardComponent from "./components/dashboad.card.component.vue";
import DashboardHeaderComponent from "./components/header/dashboard-header.component.vue";
import DashboardAccountSelectComponent from "./components/dashboard-account-select.component.vue";
import DashboardTableComponent from "./components/dashboard-table.component.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import dashboardChartMixin from "./dashboard-chart.mixin";
import { loading } from "../../assets/icons/all";

export default {
  name: "dashboard",
  mixins: [dashboardChartMixin],
  components: {
    VChart,
    DashboardAccountComponent,
    PlaceholderCardComponent,
    LogoComponent,
    DashboadCardComponent,
    DashboardHeaderComponent,
    DashboardAccountSelectComponent,
    DashboardTableComponent,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      loading: false,
      darkMode: "DARK",
      visible: null,
      accounts: [],
      chart: {},
      details_chart: {},
      banner: "",
      statistics: {},
      line_chart: [],
      sorted: {
        positive: [],
        negative: [],
      },
      init_candles: {},
      daily_change: 0,
      optionDefault: {
        label: "Hoje",
        type: "today",
      },
      menu: [
        { label: "Hoje", type: "today" },
        { label: "Semana", type: "week" },
        { label: "Mês", type: "month" },
        { label: "Trimestre", type: "quarter" },
        { label: "Semestre", type: "semester" },
        {
          label: "Ano",
          type: "year",
        },
      ],
      selectMenu: "today",

      index_account: 0,
      pie_value: null,

      update_icon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
      update_icon_active: false,
      calendarSelected: {
        start: this.moment().startOf("day").toISOString(true),
        end: this.moment().endOf("day").toISOString(true),
        shortcut: "day",
      },
      customShortcuts: [
        { key: "thisDay", label: "Hoje", value: "day" },
        { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
        { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
        { key: "last7Days", label: "Últimos 7 dias", value: 7 },
        { key: "last30Days", label: "Últimos 30 dias", value: 30 },
        { key: "thisMonth", label: "Esse mês", value: "month" },
        { key: "lastMonth", label: "Mês anterior", value: "-month" },
        { key: "thisYear", label: "Esse ano", value: "year" },
        { key: "lastYear", label: "Ano anterior", value: "-year" },
        {
          key: "last365Days",
          label: "Últimos 365 dias",
          value: () => {
            return {
              start: this.moment().subtract(365, "days"),
              end: this.moment(),
            };
          },
        },
      ],
    };
  },

  computed: {
    ...mapState({
      user_name: (state) => state.config.user_name,
      config: (state) => state.config,
    }),
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getUiTheme: "config/getUiTheme",
      ui_theme: "config/ui_theme",
    }),

    name() {
      let name = this.user_name.split(" ", 1);
      return name[0];
    },
  },

  methods: {
    setVisibility() {
      this.visible = !this.visible;
      localStorage.ontick_dashboard_visibility = this.visible;
    },
    refreshDashboard() {
      this.update_icon_active = true;
      setTimeout(() => {
        this.update_icon_active = false;
      }, 1000);
      this.getIncome(this.getSelectedAccount.account_id);
    },
    getDashboardData() {
      // console.log("getDashboardData");

      if (sessionStorage.getItem("aid") !== null) {
        this.$api.get(this.$endpoint.GET_DASHBOARD).then((response) => {
          this.banner = response.data.banner;
          // this.accounts = response.data.accounts;
          let selectedAccountIndex = response.data.accounts.findIndex(
            (item) => item.account_id === Number(sessionStorage.aid)
          );
          this.getIncome(response.data.accounts[selectedAccountIndex].account_id);
        });
      }
    },
    async getIncome(id) {
      this.loading = true;
      this.id_account = id;
      try {
        const response = await this.$api.get(`${this.$endpoint.GET_ACCOUNT_PERIOD}${this.id_account}`, {
          params: {
            start_date: this.moment(this.calendarSelected.start).format(),
            end_date:
              this.calendarSelected.end === null
                ? this.moment(this.calendarSelected.start).endOf("day").format()
                : this.moment(this.calendarSelected.end).format(),
          },
        });

        this.line_chart = response.data.equity_curve;
        this.statistics = response.data.statistics;
        this.sorted.negative = response.data.sorted_results.negative;
        this.sorted.positive = response.data.sorted_results.positive;
        this.chartLine(this.line_chart);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    getUiTheme: {
      immediate: true,
      handler() {
        let theme = localStorage.getItem("ui_theme");
        if (theme === "DARK") {
          this.darkMode = true;
        } else {
          this.darkMode = false;
        }
      },
    },
  },
  mounted() {
    this.getIncome(this.getSelectedAccount.account_id);
    // this.getTickerDetails();
    this.visible = localStorage.getItem("ontick_dashboard_visibility") === "true";
    EventBus.$once("CHANGE_ACCOUNT", () => {
      this.getIncome(this.getSelectedAccount.account_id);
    });
  },
};
</script>

<style lang="scss" scoped>
.candles .echarts {
  width: 100%;
  height: 350px;
}
.pie .echarts {
  width: 100%;
  height: 250px;
}
.line .echarts {
  width: 100%;
  min-height: 250px;
  height: 100%;
}
.box-shadow {
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.35);
}
</style>
